import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DomHandler} from 'primeng/primeng';

const componentBaseName = 'form-switch';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

export const INPUTSWITCH_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormSwitchComponent),
  multi: true,
};

@Component({
  selector: 'cat-form-switch',
  templateUrl: './form-switch.component.html',
  styleUrls: ['./form-switch.component.scss'],
  providers: [INPUTSWITCH_VALUE_ACCESSOR, DomHandler],
})
export class FormSwitchComponent implements ControlValueAccessor, AfterViewInit, AfterViewChecked {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() onLabel = 'On';

  @Input() offLabel = 'Off';

  @Input() disabled: boolean;

  @Input() style: any;

  @Input() styleClass: string;

  @Input() tabindex: number;

  @Input() inputId: string;

  @Input() ariaLabelTemplate = 'InputSwitch {0}';

  @Output() changed: EventEmitter<any> = new EventEmitter();

  checked = false;

  focused = false;

  public container: any;

  public handle: any;

  public onContainer: any;

  public offContainer: any;

  public onLabelChild: any;

  public offLabelChild: any;

  public offset: any;

  public ariaLabel: string;

  public ariaLabelledBy: string;

  initialized = false;

  constructor(public el: ElementRef, public domHandler: DomHandler) {
  }

  onModelChange = (value: boolean) => {
  }

  onModelTouched = () => {
  }

  ngAfterViewInit() {
    this.container = this.el.nativeElement.children[0];
    this.handle = this.domHandler.findSingle(this.el.nativeElement, 'div.ui-inputswitch-handle');
    this.onContainer = this.domHandler.findSingle(this.container, 'div.ui-inputswitch-on');
    this.offContainer = this.domHandler.findSingle(this.container, 'div.ui-inputswitch-off');
    this.onLabelChild = this.domHandler.findSingle(this.onContainer, 'span.ui-inputswitch-onlabel');
    this.offLabelChild = this.domHandler.findSingle(this.offContainer, 'span.ui-inputswitch-offlabel');
  }

  ngAfterViewChecked() {
    if (this.container && this.container.offsetParent && !this.initialized) {
      this.render();
    }
  }

  render() {
    const onContainerWidth = this.domHandler.width(this.onContainer);
    const offContainerWidth = this.domHandler.width(this.offContainer);
    const spanPadding = this.domHandler.innerWidth(this.offLabelChild) - this.domHandler.width(this.offLabelChild);
    const handleMargins = this.domHandler.getOuterWidth(this.handle) - this.domHandler.innerWidth(this.handle);

    let containerWidth = (onContainerWidth > offContainerWidth) ? onContainerWidth : offContainerWidth;
    let handleWidth = containerWidth;

    this.handle.style.width = handleWidth + 'px';
    handleWidth = this.domHandler.width(this.handle);
    containerWidth = containerWidth + handleWidth + 6;

    const labelWidth = containerWidth - handleWidth - spanPadding - handleMargins;

    this.container.style.width = containerWidth + 'px';
    this.onLabelChild.style.width = labelWidth + 'px';
    this.offLabelChild.style.width = labelWidth + 'px';

    /*position*/
    this.offContainer.style.width = (this.domHandler.width(this.container) - 5) + 'px';
    this.offset = this.domHandler.width(this.container) - this.domHandler.getOuterWidth(this.handle);

    /*default value*/
    if (this.checked) {
      this.handle.style.left = this.offset + 'px';
      this.onContainer.style.width = this.offset + 'px';
      this.offLabelChild.style.marginRight = -this.offset + 'px';
    } else {
      this.onContainer.style.width = 0 + 'px';
      this.onLabelChild.style.marginLeft = -this.offset + 'px';
    }

    this.initialized = true;
  }

  toggle(event, checkbox) {
    if (!this.disabled) {
      if (this.checked) {
        this.checked = false;
        this.uncheckUI();
      } else {
        this.checked = true;
        this.checkUI();
      }

      this.onModelChange(this.checked);
      this.changed.emit({
        originalEvent: event,
        checked: this.checked,
      });
      checkbox.focus();
    }
  }

  checkUI() {
    this.onContainer.style.width = this.offset + 'px';
    this.onLabelChild.style.marginLeft = 0 + 'px';
    this.offLabelChild.style.marginRight = -this.offset + 'px';
    this.handle.style.left = this.offset + 'px';
    this.updateAriaLabel();
  }

  uncheckUI() {
    this.onContainer.style.width = 0 + 'px';
    this.onLabelChild.style.marginLeft = -this.offset + 'px';
    this.offLabelChild.style.marginRight = 0 + 'px';
    this.handle.style.left = 0 + 'px';
    this.updateAriaLabel();
  }

  onFocus(event) {
    this.focused = true;
  }

  onBlur(event) {
    this.focused = false;
    this.onModelTouched();
  }

  writeValue(checked: any): void {
    this.checked = checked;

    if (this.initialized) {
      if (this.checked === true) {
        this.checkUI();
      } else {
        this.uncheckUI();
      }
    }
  }

  registerOnChange(fn): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  updateAriaLabel() {
    const pattern = /{(.*?)}/;
    const value = this.checked ? this.onLabel : this.offLabel;

    this.ariaLabel = this.ariaLabelTemplate.replace(this.ariaLabelTemplate.match(pattern)[0], value);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/components/form-switch/form-switch.component.ts